import script from "./statistic.vue?vue&type=script&setup=true&lang=js"
export * from "./statistic.vue?vue&type=script&setup=true&lang=js"

import "./statistic.vue?vue&type=style&index=0&id=2245e02e&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2245e02e"]])

export default __exports__